import React from "react";
import formStyles from "../../assets/scss/common/formStyle.module.scss";

interface SectionCardProps {
  index?: number;
  icon?: string;
  title?: string;
  subtitle?: string;
  children?: React.ReactNode;
  rightContent?: React.ReactNode;
}

const SectionCard: React.FC<SectionCardProps> = ({ icon, title, subtitle, children, rightContent }) => (
  <div className={formStyles.sectionCard}>
    <div className={formStyles.sectionHeader}>
      <i className={`${icon} ${formStyles.sectionIcon}`} />
      <div className={formStyles.sectionTitleWrap}>
        <p className={formStyles.sectionTitle}>{title}</p>
        <p className={formStyles.sectionSubtitle}>{subtitle}</p>
      </div>
      {rightContent && <div className="ms-auto">{rightContent}</div>}
    </div>
    <div className={formStyles.sectionBody}>
      {children}
    </div>
  </div>
);

export default SectionCard;
